module.exports = __webpack_public_path__ + "img/menu-mobile.69250a5a.svg";